"use strict";

var LoggerInstance = require("js-logger").get("CarouselActions");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var ProductActions = require("../actions/ProductActions");

var PartialResponseHelper = require("../shared/PartialResponseHelper");

var CarouselStore = require("../stores/CarouselStore");

var CarouselActions = {
	initializeStore: function (options) {
		var action = Object.assign({}, options, { actionType: Constants.CAROUSEL_INITIALIZE });
		Dispatcher.dispatch(action);
	},

	initializeCarousels: function ($currentCarousel) {
		if (document.readyState === "complete") {
			this._initializeCarousels($currentCarousel || $(null));
		} else {
			var _this = this;
			document.addEventListener("DOMContentLoaded", function (event) {
				_this._initializeCarousels($currentCarousel || $(null));
			});
		}
	},

	_initializeCarousels: function ($currentCarousel) {
		var handleTouchStart = function (event) {
			CarouselActions.handleTouchStart(event);
		};
		var handleTouchEnd = function (event) {
			CarouselActions.handleTouchEnd(event);
			if (CarouselActions.handleSwipe(event)) {
				event.preventDefault();
			}
			event.stopPropagation();
		};

		var $carousels = $("[data-component='carousel']");

		if ($currentCarousel.length) {
			$carousels = $carousels.filter(`#${$currentCarousel.attr("id")}`);
		}

		if ($carousels.length) {
			$carousels.each((index, carousel) => {
				carousel.addEventListener("touchstart", handleTouchStart);
				carousel.addEventListener("touchend", handleTouchEnd);

				var $carousel = $(carousel);
				ProductActions.initializeResultSuggestedDonations($carousel, `carousel_${$carousel.attr("id")}`);
			});

			if ($currentCarousel.length && $carousels.first().length) {
				//Only need to initialize when we have $currentCarousel because this means one of the paging buttons was pressed.
				//	For initial page load, the product variants initialize happens in _PublishedPageLayout
				window.ProductVariantsHelper.initializeProductVariants($carousels.first());
			}
		}
	},

	getNextPage: function (event) {
		if (CarouselStore.get("isDesignMode")) {
			return;
		}

		// Get the current carousel
		var $carousel = this._getCarousel(event);

		// Carousel-based variables
		var carouselData = this._getCarouselData($carousel);
		var currentPage = carouselData.currentPage;
		if (!currentPage) {
			currentPage = 1;
		} else {
			currentPage = +currentPage;
		}

		// Bail if we've reached the end of the records.
		if (currentPage * carouselData.limit >= carouselData.totalRecords) {
			return;
		}

		var requestedPage = currentPage + 1;
		var requestUrl = this._buildPageUrl(carouselData, requestedPage);

		// force the $carousel to load the partial page, and call unwrap because
		// we are loading the full carousel component into itself.
		var _this = this;
		$carousel.load(requestUrl, function (response, status, jqXHR) {
			if (status === "error") {
				LoggerInstance.error(jqXHR.statusText);
				PartialResponseHelper.handleErrorResponse(response);
			} else {
				var $this = $(this);
				$this.children().first().unwrap();

				Dispatcher.dispatch({
					actionType: Constants.CAROUSEL_NEXT_PAGE,
					carouselId: carouselData.id
				});
				_this.initializeCarousels($this);
			}
		});

		return false;
	},

	getPreviousPage: function (event) {
		if (CarouselStore.get("isDesignMode")) {
			return;
		}

		// Get the current carousel
		var $carousel = this._getCarousel(event);

		// Carousel-based variables
		var carouselData = this._getCarouselData($carousel);

		// Bail if we're trying to go backwards from page 1.
		if (carouselData.currentPage === 1) {
			return;
		}

		var requestedPage = carouselData.currentPage - 1;
		var requestUrl = this._buildPageUrl(carouselData, requestedPage);

		// force the $carousel to load the partial page, and call unwrap because
		// we are loading the full carousel component into itself.
		var _this = this;
		$carousel.load(requestUrl, function (response, status, jqXHR) {
			if (status === "error") {
				LoggerInstance.error(jqXHR.statusText);
				PartialResponseHelper.handleErrorResponse(response);
			} else {
				var $this = $(this);
				$this.children().first().unwrap();

				Dispatcher.dispatch({
					actionType: Constants.CAROUSEL_PREVIOUS_PAGE,
					carouselId: carouselData.id
				});
				_this.initializeCarousels($this);
			}
		});

		return false;
	},

	_getCarousel: function (event) {
		var $target = $(event.target);
		if (!$target.is("[data-component='carousel']")) {
			$target = $target.closest("[data-component='carousel']");
		}

		return $target;
	},

	_getCarouselData: function ($carousel) {
		// Carousel-based variables
		var categoryId = $carousel.attr("data-category") || null;
		var id = $carousel.attr("id");
		var limit = +$carousel.attr("data-limit");
		var totalRecords = +$carousel.attr("data-total-records");
		var tangibleCode = $carousel.attr("data-tangible-code");

		// Store variables
		var layoutId = CarouselStore.get("layoutId");
		var url = CarouselStore.get("url");
		var currentPage = +CarouselStore.get("carouselCurrentPages")[id];

		return { categoryId, id, limit, totalRecords, layoutId, url, currentPage, tangibleCode };
	},

	_buildPageUrl(carouselData, requestedPage) {
		var url = carouselData.url;

		var params = [];
		if (carouselData.layoutId) {
			params.push("layoutId=" + carouselData.layoutId);
		}

		if (carouselData.categoryId) {
			params.push("categoryId=" + carouselData.categoryId);
		}

		if (carouselData.tangibleCode) {
			params.push(`tangibleCode=${carouselData.tangibleCode}`);
		}

		if (params.length > 0) {
			url += "?" + params.join("&");
		}

		url += "&offset=" + (carouselData.limit * (requestedPage - 1));
		url += "&id=" + carouselData.id;

		return url;
	},

	// Swipe logic
	handleTouchStart(event) {
		if (event && event.changedTouches) {
			Dispatcher.dispatch({
				actionType: Constants.CAROUSEL_TOUCH_START,
				touchstartX: event.changedTouches[0].screenX
			});
		}
		return false;
	},

	handleTouchEnd(event) {
		if (event && event.changedTouches) {
			Dispatcher.dispatch({
				actionType: Constants.CAROUSEL_TOUCH_END,
				touchendX: event.changedTouches[0].screenX
			});
		}
		return false;
	},

	//Will return true if the swipe was detected and handled; otherwise, false.
	handleSwipe(event) {
		var swipeBuffer = 15; // If the diff between toundstartX and touchendX is less than swipeBuffer, don't count it as a swipe
		var touchstartX = CarouselStore.get("touchstartX");
		var touchendX = CarouselStore.get("touchendX");
		var touchDiff = Math.abs(touchstartX - touchendX);

		if (touchDiff > swipeBuffer) {
			if (touchendX < touchstartX) {
				this.getNextPage(event);
			} else {
				this.getPreviousPage(event);
			}
			return true;
		}

		return false;
	}
};

module.exports = CarouselActions;